import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { FilterPanel } from '@gsa/afp-component-library';
import { useFederalStandards } from '../../../fvs-provider';

const { FilterPanelField, FilterPanelFilterShape } = FilterPanel;

const FederalStandardCodeFilterItem = ({ filter }) => {
  const {
    vehicleClassificationOptions,
  } = useFederalStandards();

  const options = useMemo(() => {
    const baseOptions = vehicleClassificationOptions?.fedStandardCode || [];
    return [{ label: 'Select federal standard code', value: '' }, ...baseOptions];
  }, [vehicleClassificationOptions?.fedStandardCode]);

  return (
    <>
      <label htmlFor={filter.key} className="usa-label">
        {filter.title}
      </label>
      <FilterPanelField
        key={[filter.key]}
        filter={{
          ...filter,
          type: 'select',
          options,
        }}
      />
    </>
  );
};

FederalStandardCodeFilterItem.propTypes = {
  filter: PropTypes.shape(FilterPanelFilterShape).isRequired,
};

export default FederalStandardCodeFilterItem;
